<template>
    <div>
        <a-modal class="modalStyle" :dialog-style="{ top: '20px' }" :width="650" :visible="invoiceModalVisible"
            :footer="null" @cancel="handleInvoiceModalCancel">
            <div class="container">
                <div class="d-flex justify-content-between">
                    <div class="logoContainer">
                        <div class="image"></div>
                    </div>
                    <div class="invoice-text">
                        Purchase Order
                    </div>
                </div>
                <div class="d-flex justify-content-between">
                    <div class="cowtribe-container">
                        <br>
                        <h3> {{ data.sellerName ? data.sellerName : "" }} </h3>
                        <p>{{ data.sellerAddress ? data.sellerAddress : "" }}</p>
                        <p>{{ data.sellerCity ? data.sellerCity : "" }}</p>
                        <p>{{ data.sellerCountry ? data.sellerCountry : "" }}</p>
                        <p>Date: {{ data.cowtribeDate ? data.cowtribeDate : '' }}</p>
                    </div>
                    <div class="retailer-details">
                        <p>Shipped to,</p>
                        <p>{{ data.retailerName ? data.retailerName : '' }}</p>
                        <div>
                            {{ data.retailerAddress ? data.retailerAddress : '' }}
                            <br />
                            {{ data.retailerCity ? data.retailerCity : '' }}
                            <br />
                            {{ data.retailerCountry ? data.retailerCountry : '' }}
                        </div>
                    </div>

                    <div class="divider">
                        <a-divider></a-divider>
                    </div>
                    <div>
                        <div class="d-flex justify-content-between">
                            <div class="invoice-header-1">Order number</div>
                            <div class="invoice-header-2">Shipping Method</div>
                            <div class="invoice-header-3">Delivery Date</div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div class="invoice-value-1">{{ data.id ? `#${data.id}` : 'N/A' }}</div>
                            <div class="invoice-value-2">{{ data.shippingMethodLabel ? data.shippingMethodLabel :
            'N/A' }}</div>
                            <div class="invoice-value-3">{{ data.deliveryDate ? data.deliveryDate : 'N/A' }}</div>
                        </div>
                    </div>
                    <div class="divider-2">
                        <a-divider></a-divider>
                    </div>
                    <div class="tableContainer tableFixHead">
                        <table class="table table-striped table-hover table-bordered fixed_header">

                            <thead>
                                <tr>
                                    <th scope="col">Product Name</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">UnitPrice(Ksh)</th>
                                    <th scope="col">LineTotal(Ksh)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="product in data.products" :key="product.id">
                                    <td>{{ product.productName }}</td>
                                    <td>{{ product.quantity }}</td>
                                    <td>{{ product.unitPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                                    </td>
                                    <td>{{ product.lineTotal.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="subTotal d-flex justify-content-between">
                        <p>Sub Total</p>
                        <p>{{ data.subTotal ? `Ksh ${data.subTotal.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
            : 'N/A' }} </p>
                    </div>
                    <div class="discount d-flex justify-content-between">
                        <p>Discount</p>
                        <p> - {{ data.discount }}</p>
                    </div>
                    <div class="total d-flex justify-content-between">
                        <p>Total</p>
                        <p>{{ data.total ? `Ksh ${data.total.toLocaleString(undefined, { minimumFractionDigits: 2 })}` :
                            'N/A'}} </p>
                    </div>
                    <div class="termContainer">
                        <p>Shipping Terms</p>
                        <p>
                            {{ data.terms ? data.terms : "N/A" }}
                        </p>
                    </div>

                    <div class="divider-3">
                        <a-divider></a-divider>
                    </div>

                    <div class="d-flex justify-content-between">
                        <div class="address-value-1">www.zhulia.me</div>
                        <div class="address-value-2">sales@zhulia.me</div>
                        <div class="address-value-3">+233559691061</div>
                    </div>
                </div>

            </div>

        </a-modal>
    </div>
</template>

<script>
export default {
    name: 'Invoice',
    data() {
        return {
            invoiceModalVisible: false,
            data: {
                sellerName: "",
                terms: "",
                sellerAddress: "",
                sellerCity: "",
                sellerCountry: "",
                retailerName: '',
                retailerAddress: '',
                retailerCity: '',
                retailerCountry: '',
                discount: 0,
                subTotal: '',
                cowtribeDate: '',
                id: '',
                shippingMethodLabel: '',
                deliveryDate: '',
                total: '',
                products: [],
            }
        }
    },
    methods: {
        handleInvoiceModalCancel() {
            this.invoiceModalVisible = false
        },
        showInvoiceForm(invoiceData) {
            this.data = invoiceData
            this.invoiceModalVisible = true
        },

    },


}
</script>

<style scoped>
.modalStyle>>>.ant-modal-header {
    border-bottom: none;
}

.modalStyle>>>.ant-modal-footer {
    border-top: none;
}

.modalStyle {
    display: flex;
    justify-content: center;
}

.container {
    height: 842px;
    background: #FFFFFF;
}

.logoContainer {
    position: absolute;
    width: 212px;
    height: 64px;
    left: 31px;
    top: 25px;
    color: #FFFFFF;
    background: #266423;
}

.image {
    position: absolute;
    width: 156px;
    height: 39px;
    left: 56px;
    top: 12px;
    background: url('../../../assets/img/invoice-log.png');
}

.invoice-text {
    position: absolute;
    width: 186px;
    height: 44px;
    left: 423px;
    top: 30px;
    font-weight: 600;
    font-size: 22px;
    line-height: 44px;
    text-align: right;
    letter-spacing: 0.05em;
    color: #6F6F84;
}

.cowtribe-container h3 {
    position: absolute;
    width: 400px;
    height: 35px;
    left: 30px;
    top: 105px;
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
    color: #000000;
}

.cowtribe-container p:first-of-type {
    position: absolute;
    width: 300px;
    height: 17px;
    left: 30px;
    top: 143px;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.cowtribe-container p:nth-child(2) {
    position: absolute;
    width: 300px;
    height: 17px;
    left: 30px;
    top: 155px;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.cowtribe-container p:nth-child(3) {
    position: absolute;
    width: 300px;
    height: 17px;
    left: 30px;
    top: 140px;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.cowtribe-container p:nth-child(4) {
    position: absolute;
    width: 300px;
    height: 17px;
    left: 30px;
    top: 165px;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.cowtribe-container p:nth-child(5) {
    position: absolute;
    width: 300px;
    height: 17px;
    left: 30px;
    top: 186px;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.cowtribe-container p:last-of-type {
    position: absolute;
    width: 300px;
    height: 17px;
    left: 30px;
    top: 207px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #222234;
}

.retailer-details p:first-of-type {
    position: absolute;
    width: 106px;
    height: 17px;
    left: 507px;
    top: 89px;
    font-size: 14px;
    line-height: 17px;
    text-align: right;
    color: #6F6F84;
}

.retailer-details p:nth-child(2) {
    width: 100%;
    margin-left: 159px;
    margin-top: 89px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-align: right;
    color: #222234;
}

.phoneNumber {
    width: 100%;
    margin-left: 145px;
    margin-top: 181px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    text-align: right;
    color: #222234;
}


.retailer-details div {
    position: absolute;
    width: 173px;
    height: 60px;
    left: 439px;
    top: 133px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 25px;
    text-align: right;
    color: #6F6F84;
}

.divider {
    position: absolute;
    width: 581px;
    height: 0px;
    left: 30px;
    top: 205px;
}

.divider-2 {
    position: absolute;
    width: 581px;
    height: 0px;
    left: 30px;
    top: 300px;
}

.divider-3 {
    position: absolute;
    width: 581px;
    height: 0px;
    left: 30px;
    top: 825px;
}

.invoice-header-1 {
    position: absolute;
    width: 102px;
    height: 17px;
    left: 30px;
    top: 255px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.invoice-header-2 {
    position: absolute;
    width: 150px;
    height: 17px;
    left: 266px;
    top: 254px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.invoice-header-3 {
    position: absolute;
    width: 150px;
    height: 17px;
    left: 467px;
    top: 252px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.invoice-value-1 {
    position: absolute;
    width: 100px;
    height: 17px;
    left: 30px;
    top: 277px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #222234;
}

.invoice-value-2 {
    position: absolute;
    width: 200px;
    height: 17px;
    left: 266px;
    top: 276px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #222234;
}

.invoice-value-3 {
    position: absolute;
    width: 100%;
    height: 17px;
    left: 467px;
    top: 274px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #222234;
}

.tableContainer {
    position: absolute;
    width: 581px;
    height: 195px;
    left: 31px;
    top: 372px;
    background: #FAFAFC;
    border: 1px solid #BCB0C4;
    box-sizing: border-box;
    border-radius: 8px;
}

.tableFixHead {
    overflow-y: auto;
    height: 200px;
}

.tableFixHead thead th {
    position: sticky;
    top: 0;
}

.tableFixHead table {
    border-collapse: collapse;
    width: 100%;
}

.tableFixHead th,
.tableFixHead td {
    padding: 8px 16px;
    border: 1px solid #ccc;
}

.tableFixHead th {
    background: #eee;
}

.subTotal {
    position: absolute;
    width: 88%;
    height: 15px;
    left: 31px;
    top: 599px;
}

.discount {
    position: absolute;
    width: 88%;
    height: 15px;
    left: 31px;
    top: 633px;
}

.discount p:first-of-type {
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 15px;
    letter-spacing: 0.05em;
    color: #6F6F84;
}

.discount p:last-of-type {
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 15px;
    color: #222234;
}

.total {
    position: absolute;
    width: 88%;
    height: 15px;
    left: 31px;
    top: 670px;
}

.total p:first-of-type {
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 15px;
    letter-spacing: 0.05em;
    color: #6F6F84;
}

.subTotal p:first-of-type {
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 15px;
    letter-spacing: 0.05em;
    color: #6F6F84;
}

.subTotal p:last-of-type {
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 15px;
    color: #222234;
}

.total p:last-of-type {
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 15px;
    color: #222234;
}

.termContainer {
    position: absolute;
    height: 12px;
    left: 31px;
    width: 88%;
    top: 740px;
    font-weight: 500;
    font-size: 10px;
    line-height: 12px;
    font-size: 13px;
    letter-spacing: 0.05em;
    color: #6F6F84;
}

.termContainer p:first-of-type {
    font-size: 16px;
    color: #222234;
    line-height: 17px;
}

.termContainer p:last-of-type {
    line-height: 19px;
}

.ant-divider-horizontal {
    border: 1px solid #C7C7C7;
}

.paymentDetails {
    position: absolute;
    height: 15px;
    left: 30px;
    top: 727px;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    font-size: 16px;
    color: #222234;
}

.paymentDetails_2 {
    position: absolute;
    height: 15px;
    left: 380px;
    top: 727px;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    font-size: 16px;
    color: #222234;
}

.bog {
    position: absolute;
    height: 17px;
    left: 30px;
    top: 754px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.bog_2 {
    position: absolute;
    height: 17px;
    left: 380px;
    top: 754px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.acount {
    position: absolute;
    height: 17px;
    left: 30px;
    top: 782px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.acount_2 {
    position: absolute;
    height: 17px;
    left: 380px;
    top: 782px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}


.adresss {
    position: absolute;
    height: 17px;
    left: 30px;
    top: 810px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.adresss_2 {
    position: absolute;
    height: 17px;
    left: 380px;
    top: 810px;
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.address-value-1 {
    position: absolute;
    width: 100px;
    height: 17px;
    left: 30px;
    top: 859px;
    font-size: 14px;
    line-height: 17px;
    color: #418A49;
}

.address-value-2 {
    position: absolute;
    width: 110px;
    height: 17px;
    left: 252px;
    top: 859px;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}

.address-value-3 {
    position: absolute;
    /* width: 112px; */
    height: 17px;
    left: 466px;
    top: 859px;
    font-size: 14px;
    line-height: 17px;
    color: #6F6F84;
}
</style>